import React, {Component} from 'react'
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card'
import {Tabs, Tab} from 'material-ui/Tabs'
import {cardStyles, styles} from '../Constants'
import Paper from 'material-ui/Paper'

import * as firebase from 'firebase'


export default class Messaging extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messages: [],
      sms_messages: [],
    }
  }

  componentWillMount() {
    let self = this
    firebase.database().ref("/admin_messages/").on("value", function(snap) {
      let lst = []
      if(snap.val()) {
        snap.forEach(function(child) {
          let item = child.child("lastMessage").val()
          item.key = child.ref.key
          console.log(item)
          lst.push(item)
        })
        self.setState({
          messages: lst,
        })
      }
    })
  }

  render() {
    return (
      <Paper style={cardStyles}>
        <CardHeader
          actAsExpander={true}
          showExpandableButton={true}
          title="Messaging"
          subtitle="Chat w/ Customers"
          avatar="footer.jpg"/>
        <CardText
          expandable={true}>
          <Tabs>
            <Tab label="Messages" value="a">
            <br/>
            {this.state.messages.map(function(m) {
              console.log(m)
              return (
                <Paper key={m.key} zDepth={2}>
                  <CardHeader
                    key={m.key}
                    title={m.lastMessageUserName}
                    avatar={m.lastMessagePhoto}/>
                    <p style={{paddingBottom: '5px'}}>
                      &nbsp;&nbsp;&nbsp;&nbsp;{m.message}
                    </p>
                </Paper>
              )
            })}
            </Tab>
            <Tab label="SMS" value="b">
              <div>
              <br/>
                <h2 style={styles.headline}>BrainTree</h2>
              </div>
            </Tab>
          </Tabs>
        </CardText>
      </Paper>
    )
  }

}



// WEBPACK FOOTER //
// ./src/react/Messaging.js